import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Base sheet first: component stylesheets are imported by the components
// themselves, so they must land after app.css to win on equal specificity.
import "./styles/app.css";
import { App } from "./App";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
